module.exports = __webpack_public_path__ + "img/Peritécios, Ascas e Ascósporos 2.4cf30c32.webp";